import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BannerContext = createContext(null);

const SESSION_DISMISS_KEY = "hk_banner_dismissed";

export const BannerProvider = ({ children }) => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(SESSION_DISMISS_KEY) || null;
    } catch {
      return null;
    }
  });

  const fetchActive = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/banners/active`);
      setBanner(res.data || null);
    } catch {
      setBanner(null);
    }
  }, []);

  useEffect(() => {
    fetchActive();
    const t = setInterval(fetchActive, 60_000); // refresh every 60s
    return () => clearInterval(t);
  }, [fetchActive]);

  const dismiss = () => {
    if (!banner) return;
    try {
      sessionStorage.setItem(SESSION_DISMISS_KEY, banner.id);
    } catch {}
    setDismissed(banner.id);
  };

  const isDismissed = banner && dismissed === banner.id;
  const value = { banner, isDismissed, dismiss, refresh: fetchActive };
  return <BannerContext.Provider value={value}>{children}</BannerContext.Provider>;
};

export const useBanner = () => {
  const ctx = useContext(BannerContext);
  if (!ctx) throw new Error("useBanner must be used within BannerProvider");
  return ctx;
};
